module.exports = __webpack_public_path__ + "img/KonrInsta_final.e8d5efd8.jpg";